var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.userPermissions.includes("SingleSitePageView")
    ? _c(
        "div",
        {
          staticClass: "live-pml",
        },
        [
          _c(
            "div",
            {
              staticClass: "container-fluid pt-3",
            },
            [
              _c(
                "div",
                {
                  staticClass: "row justify-content-center",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12",
                    },
                    [_vm.data.fleet ? _c("live-pml-table") : _vm._e()],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    : _c("div", [
        _c(
          "div",
          {
            staticClass: "container-fluid pt-3",
          },
          [
            _c("access-denied-modal", {
              on: {
                clickedcanceleditstate: _vm.onClickCancel,
              },
            }),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }